import Label from './Label';
import ErrorMessage from './ErrorMessage';

const AchField = ({ field, label, wrapper }) => (
  <div className="flex w-full flex-col gap-1">
    <Label htmlFor={field} required>
      {label}
    </Label>
    <div className={`${wrapper} ${field}-wrapper`}>
      <div className={`${field} w-full`}></div>
    </div>
    <ErrorMessage className={`${field}-error`} />
  </div>
);

export default AchField;
